import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';
// TODO: differentiate between 2 letter and 3 letter codes
interface CountryCodeBrand {
    readonly CountryCode: unique symbol;
}
export const CountryCode = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, CountryCodeBrand> => true,
    'CountryCode'
);
export type CountryCode = TypeOf<typeof CountryCode>;
